export default __webpack_public_path__ + "static/media/logo-white-blue-bg.48c80026.svg";